// extracted by mini-css-extract-plugin
export default {"hiddenText":"MessageButton_hiddenText__1d3vh","messageButtonText":"MessageButton_messageButtonText__gW0Bq"};